export default {
  // تسجيل الدخول
  login: {
    lang: 'اللغة',
    systemname: 'دخول',
    username: 'المستخدم',
    username_label: 'يرجى إدخال اسم المستخدم',
    pwd: 'كلمة المرور',
    pwd_label: 'يرجى إدخال كلمة المرور',
    pwd_info: 'أدخل صيغة كلمة مرور صحيحة',
    success_msg: 'تم تسجيل الدخول بنجاح',
    error_name: 'كلمة المرور غير صحيحة',
    error_res: 'لا يلبي متطلبات الدخول',
    login: 'تسجيل الدخول',
  },
  // الشريط الجانبي
  aside: {
    systemname: 'لوحة',
    quit: 'تسجيل الخروج',
    deviceControl: 'التحكم',
    basicSetting: 'الإعدادات',
    workerSetting: 'الأفراد',
    deviceMonitoring: 'المراقبة',
    recordManagement: 'السجلات',
    securityManagement: "إدارة المفاتيح",
    tips: 'تنبيه',
    tips_msg: 'هل تريد تسجيل الخروج؟',
  },
  control: {
    remoteControl: 'عن بعد',
    restart: 'إعادة تشغيل',
    clickToRestart: 'اضغط لإعادة التشغيل',
    restartConfirm: 'تأكيد إعادة التشغيل؟',
    restartSuccess: 'تمت إعادة التشغيل',
    restartFailed: 'فشلت إعادة التشغيل',
    remoteOpen: 'فتح الباب عن بعد',
    clickToOpen: 'اضغط للفتح',
    openConfirm: 'تأكيد الفتح عن بعد؟',
    remoteOpenSuccess: 'تم الفتح بنجاح',
    remoteOpenFailed: 'فشل الفتح',
    reset: 'إعادة ضبط الجهاز',
    clickToReset: 'اضغط لإعادة الضبط',
    resetConfirm: 'تأكيد إعادة الضبط؟',
    resetSuccess: 'تمت إعادة الضبط',
    resetFailed: 'فشلت إعادة الضبط',
    firmwareUpgrade: 'تحديث البرنامج الثابت',
    upgradeConfig: 'إعدادات التحديث',
    firmwareUrl: 'رابط البرنامج',
    md5Checksum: 'قيمة md5',
    startUpgrade: 'بدء التحديث',
    urlRequired: 'الرابط مطلوب',
    md5Required: 'قيمة md5 مطلوبة',
    urlInvalid: 'يرجى إدخال رابط صحيح',
    md5Invalid: 'يرجى إدخال md5 صحيح',
    upgradeConfirm: 'تأكيد التحديث؟',
    upgradeSuccess: 'تم التحديث بنجاح',
    clearFile: "مسح الملف",
    uploading: 'جاري الرفع...',
    uploadAndUpgrade: 'رفع وتحديث',
    restartTips: 'إعادة تشغيل آمنة دون فقدان البيانات',
    restarting: 'جاري إعادة التشغيل...',
    remoteTips: 'تحكم عن بعد بالوصول',
    opening: 'جاري الفتح...',
    resetTips: 'إرجاع إعدادات المصنع، سيحذف البيانات',
    reseting: 'جاري الإعادة...',
    urlUpgrade: 'تحديث عبر الرابط',
    fileUpgrade: 'تحديث عبر ملف',
    uploadFile: 'اضغط لرفع ملف البرنامج',
    formatFile: 'يدعم .zip أو .dpk، الحد 20MB',
    fileName: 'اسم الملف',
    size: 'الحجم',
  },
  config: {
    second: 'ث',
    millisecond: 'ملث',
    min: 'دقائق',
    notsave: 'لا تحفظ',
    save: 'حفظ',
    noVoice: 'بدون صوت',
    no: 'لا',
    yes: 'نعم',
    basicConfiguration: 'الإعدادات الأساسية',
    displaySettings: 'إعدادات العرض',
    informationDisplay: 'عرض المعلومات',
    audioSettings: 'إعدادات الصوت',
    languageAndThemes: 'اللغة والسمات',
    autoAdjustScreenBrightness: 'سطوع تلقائي',
    screenBrightness: 'سطوع الشاشة',
    autoTurnOffScreen: 'إيقاف الشاشة تلقائياً',
    autoTurnOffScreenTime: 'زمن الإيقاف',
    autoScreenSaver: 'حافظة شاشة تلقائية',
    autoScreenSaverTime: 'زمن الحافظة',
    displayDeviceSn: 'عرض SN',
    displayIp: 'عرض IP',
    displayIdentityCard: 'عرض شهادة السحابة',
    volume: 'مستوى الصوت',
    language: 'اللغة',
    displayCode: "عرض رمز التطبيق المصغر",
    themeMode: "نمط العمل",
    cn: 'الصينية',
    en: 'الإنجليزية',
    es: 'الإسبانية',
    fr: 'الفرنسية',
    de: 'الألمانية',
    ru: 'الروسية',
    ar: 'العربية',
    pt: 'البرتغال',
    ko: 'الكورية',
    standardMode: 'الوضع القياسي',
    simpleMode: 'الوضع المبسط',
    firstLogin: 'أول تسجيل دخول',
    backlight: 'إضاءة خلفية الشاشة',
    brightness: 'الإضاءة البيضاء',
    nirBrightness: 'إضاءة الأشعة تحت الحمراء',
    never: 'أبداً',
    min1: 'دقيقة',
    min2: 'دقيقتان',
    min3: '3 دقائق',
    min4: '4 دقائق',
    min5: '5 دقائق',
    networkConfiguration: 'إعدادات الشبكة',
    otherConfiguration: 'إعدادات أخرى',
    ipConfiguration: 'تكوين IP',
    devicePassword: 'كلمة مرور الجهاز',
    protocolPassword: 'كلمة مرور البروتوكول',
    networkType: 'نوع الشبكة',
    ethernet: 'إيثرنت',
    wifiName: 'اسم Wi‑Fi',
    wifiPassword: 'كلمة مرور Wi‑Fi',
    dhcpModeSelection: 'وضع DHCP',
    dhcpMode: 'تلقائي',
    customNetworkConfiguration: 'يدوي',
    ipAddress: 'عنوان IP',
    gateway: 'البوابة',
    subnetMask: 'قناع الشبكة',
    dnsServer: 'خادم DNS',
    mac: 'عنوان MAC',
    mqttRelatedConfiguration: 'إعدادات MQTT',
    mqttConnectionInformation: 'معلومات اتصال MQTT',
    sessionConfiguration: 'إعدادات الجلسة',
    serverAddress: 'عنوان الخادم',
    clientID: 'معرّف العميل',
    userName: 'اسم المستخدم',
    userPassword: 'كلمة المرور',
    topicPrefix: 'بادئة الموضوع',
    onlineChecking: 'تحقق عبر الإنترنت',
    onlineCheckingTimeout: 'مهلة التحقق',
    cleanSession: 'تنظيف الجلسة',
    clientIdSuffix: 'لاحقة المعرّف',
    willTopic: 'موضوع Will',
    enterpriseWechat:'وضع Enterprise WeChat غير مفعل',
    faceRelatedConfiguration: 'إعدادات الوجه',
    functionalInformation: 'معلومات الوظيفة',
    prompt: 'تنبيه',
    faceSimilarityThreshold: 'عتبة التشابه',
    livenessDetectionFunction: 'كشف الحيوية',
    livenessDetectionThreshold: 'عتبة الحيوية',
    infraredImageDisplay: "عرض الأشعة تحت الحمراء",
    maskRecognition: "التعرف على القناع",
    strangerVoice: "صوت الغريب",
    voiceMode: "وضع الصوت",
    voiceModeDate: 'تحية مخصصة',
    imageSaveType: "نوع الحفظ",
    saveStrangerImage: "حفظ صورة الغريب",
    fullView: "بانوراما",
    face: "الوجه",
    broadcastPleaseRegisterFirst: 'تشغيل "سجل أولاً"',
    broadcastHelloStranger: 'تشغيل "غريب"',
    broadcastName: 'تشغيل الاسم',
    broadcastGreeting: 'تشغيل تحية مخصصة',
    greeting: 'تحية',
    broadcastWelcome: 'تشغيل "مرحباً"',
    recognitionSwitch: 'مفتاح إعادة الكشف',
    systemRelatedConfiguration: 'إعدادات النظام',
    functionSwitch: 'مفاتيح الوظائف',
    cardSwipingSwitch: 'البطاقة',
    passwordSwitch: 'كلمة المرور',
    strangerImage: 'صورة الغريب',
    cloudCertificateSwitch: 'شهادة السحابة',
    physicalCardNumber: 'رقم البطاقة الفيزيائية',
    cloudCertificateAcquisition: 'الحصول على شهادة السحابة',
    heartbeatConfig: 'نبضات القلب',
    heartbeatSwitch: 'تفعيل النبضات',
    heartRateInterval: 'الفاصل الزمني',
    heartbeatTopic: 'موضوع النبض',
    heartbeatContent: 'محتوى النبض',
    basicInformation: 'معلومات أساسية',
    deviceMac: 'عنوان MAC',
    uuid: 'UUID',
    sn: 'SN',
    model: 'الطراز',
    version: "الإصدار",
    appVersion: "إصدار البرنامج",
    releaseTime: "وقت التحديث",
    totaldisk: 'المساحة الإجمالية',
    freedisk: 'المساحة المتبقية',
    passageConfiguration: 'إعدادات المرور',
    functionConfiguration: 'إعدادات الوظائف',
    numberOfPassageRecords: 'الحد الأقصى للسجلات',
    durationOfRelayOpening: 'مدة فتح المرحل',
    alarmSwitch: 'إنذار',
    fireAlarmSwitch: 'إنذار حريق',
    fireAlarmStatus: 'حالة الحريق',
    normal: 'طبيعي',
    warning: 'تحذير',
    tamperSwitch: 'إنذار العبث',
    uploadToCloudSwitch: 'مفتاح تحميل الوجه',
    clockConfiguration: 'إعدادات الوقت',
    timeSynchronizationSwitch: 'مزامنة الوقت',
    timeSynchronizationServerIP: 'خادم الوقت',
    timedSynchronizationTime: 'وقت المزامنة',
    timeZone: 'المنطقة الزمنية',
    setDeviceTime: 'ضبط وقت الجهاز',
    restartAfterSetting: 'سيُعاد تشغيل الجهاز بعد الضبط',
    cloudCertificateActivation: 'تفعيل شهادة السحابة',
    activationKey: 'مفتاح التفعيل',
    cloudTips1: 'أدخل المفتاح بدون مسافات',
    cloudTips2: 'بعد التفعيل سيتصل بخدمة السحابة',
    confirmActivation: 'تأكيد التفعيل',
    activationInProgress: 'جاري التفعيل...',
    activationFailed: 'فشل التفعيل',
    activationSuccessful: 'تم التفعيل بنجاح',
    passwordModification: 'تغيير كلمة المرور',
    password: 'كلمة المرور',
    oldPassword: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordRule: 'توصيات كلمة المرور',
    passwordLength: 'الطول ≥6',
    cannotBeTheSame: 'لا يمكن أن تكون كل الأحرف متطابقة',
    cannotOrder: 'لا يشمل 3+ أرقام/حروف متتالية',
    cannotWeakPassword: 'لا تستخدم كلمات مرور ضعيفة شائعة',
    submit: 'إرسال',
    saveConfig: 'حفظ الإعدادات',
    msg_please_enter: 'يرجى الإدخال',
    msg_inputPassword: 'يرجى إدخال كلمة المرور',
    msg_oldPasswordError: 'كلمة المرور القديمة غير صحيحة',
    msg_password_mismatch: 'كلمتا المرور غير متطابقتين',
    msg_password_min_length: 'الحد الأدنى 6 أحرف',
    msg_is_weak_password: 'كلمة مرور ضعيفة، يرجى التغيير',
    msg_pswChangeSuccessAndLogin: 'تم تغيير كلمة المرور، يرجى تسجيل الدخول',
    msg_pswChangeSuccess: 'تم تغيير كلمة المرور',
    msg_pswChangeFail: 'فشل تغيير كلمة المرور',
    msg_saveSuccess: 'تم الحفظ بنجاح',
    msg_saveFail: 'فشل الحفظ',
    msg_formFilled: 'تحقق من تعبئة النموذج',
    msg_number_0_23: 'يدعم فقط 0 إلى 23',
    msg_number_0_24: 'يدعم فقط 0 إلى 24',
    msg_noChange: 'لا توجد تغييرات في الإعدادات للحفظ',
    resourceConfiguration: 'إعدادات الموارد',
    backgroundImage: 'صورة الخلفية',
    selectImage: 'اختر صورة',
    uploadBackground: 'رفع الخلفية',
    uploading: 'جارٍ الرفع...',
    backgroundUploadTip: 'يرجى تحميل صورة بصيغة PNG بحجم البكسلات {n}، وسيتم تحويل الصورة إلى صيغة Base64 ثم نقلها إلى الجهاز',
    backgroundResolutionMismatch: 'يجب أن تكون دقة الصورة {n}',
    backgroundRequired: 'يرجى اختيار صورة خلفية',
    backgroundImageOnlyPNG: 'PNG فقط',
    backgroundSizeLimit: 'الحجم لا يتجاوز 5MB',
    backgroundParseFailed: 'فشل قراءة الصورة',
    backgroundImageSelected: 'تم اختيار الصورة',
    backgroundSuccess: 'تم رفع الخلفية',
    backgroundFailed: 'فشل رفع الخلفية',
    scanSettings: 'إعدادات المسح',
    scanSwitch: 'مفتاح المسح',
    scanInterval: 'فاصل المسح'
  },
  person: {
    idCard: 'رقم الهوية',
    userType: 'نوع المستخدم',
    administrator: 'مسؤول',
    userId: 'ID',
    user: 'مستخدم',
    voucher: 'بيان اعتماد',
    permission: 'الصلاحية',
    addUser: 'إضافة مستخدم',
    name: 'الاسم',
    editUser: 'تعديل المستخدم',
    placeholderUserId: 'أدخل معرف المستخدم',
    placeholderName: 'أدخل الاسم',
    userNotExist: 'المستخدم غير موجود',
    oneClickClear: 'مسح الكل',
    clearTips: 'سيتم حذف جميع البيانات، المتابعة؟',
    clearSuccess: 'تم المسح بنجاح',
    clearFailed: 'فشل المسح',
  },
  voucher: {
    password: 'كلمة المرور',
    card: 'بطاقة',
    face: 'وجه',
    finger: 'بصمة',
    code: "الرمز",
    codeType: "نوع الرمز",
    passthroughCode: "رمز التمرير",
    staticCode: "رمز ثابت",
    dynamicCode: "رمز ديناميكي",
    placeholderCode: "الرجاء إدخال رمز الشهادة",
    placeholderPwd: 'أدخل كلمة المرور',
    placeholderCard: 'أدخل البطاقة',
    validPassword: 'أدخل 6 أرقام',
    validCard: 'أدخل 8 أرقام أو أحرف',
    photoRegistration: 'تسجيل صورة',
    featureValueRegistration: 'تسجيل السمات',
    fingerRegistration: 'تسجيل البصمة',
    fingerFeatureRegistration: 'تسجيل قيمة السمة',
    fingerInput: 'يرجى وضع إصبعك على ماسح البصمة',
    fingerRemainingTime: 'الوقت المتبقي',
    fingerInputting: 'جارٍ التسجيل...',
    startFingerInput: 'بدء تسجيل البصمة',
    fingerInputTips: 'يرجى إدخال قيمة سمة البصمة',
    fingerWaitInput: 'بانتظار التسجيل',
    fingerInputNow: 'جارٍ تسجيل البصمة...',
    fingerInputSuccess: 'تم التسجيل بنجاح',
    fingerInputFailed: 'فشل بدء تسجيل البصمة',
    fingerReTry: 'فشل تسجيل البصمة، يرجى المحاولة مرة أخرى',
    fingerFilled: 'تم تسجيل البصمة بنجاح وتم تعبئة قيمة السمة تلقائيًا',
    fingerFailed: 'فشل تسجيل البصمة',
    fingerTimeout: 'انتهت المهلة',
    fingerInputTimeout: 'انتهت مهلة تسجيل البصمة، يرجى المحاولة مرة أخرى',
    fingerError: 'فشل التسجيل',
    fingerInputError: 'فشل تسجيل البصمة، يرجى المحاولة مرة أخرى',
    fingerInputed: 'تم تسجيل البصمة',
    fingerReInput: 'إعادة تسجيل البصمة',
  
  },
  permission: {
    deletePermission: 'حذف الصلاحية',
    addPermission: 'إضافة صلاحية',
    permissionId: 'معرّف الصلاحية',
    userId: 'معرّف المستخدم',
    timeRange: 'النطاق الزمني',
    extra: 'إضافي',
    effectiveType: 'نوع الفعالية',
    effectiveTime: 'وقت الفعالية',
    effectiveWeek: 'الأسبوع الفعال',
    timePeriod: 'الفترة الزمنية',
    addTimePeriod: 'إضافة فترة',
    modify_previous_time: 'عدّل الفترة السابقة أولاً',
    cannot_be_earlier: 'لا يمكن أن تكون النهاية قبل البداية',
    times_cannot_overlap: 'لا يمكن تداخل الأوقات',
    choose_time_range: 'اختر نطاق الزمن',
    unlimitedMode: 'غير محدود',
    usualMode: 'الوضع المعتاد',
    dailyMode: 'وضع يومي',
    weeklyRepetitionMode: 'تكرار أسبوعي',
    time_range: 'النطاق الزمني',
  },
  common: {
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    to: 'إلى',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    delete: 'حذف',
    edit: 'تعديل',
    batchDelete: 'حذف دفعة',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',
    monday: 'الاثنين',
    tuseday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saterday: 'السبت',
    sunday: 'الأحد',
    placeholder: 'يرجى الإدخال',
    placeholderSelect: 'يرجى الاختيار',
    closeTips: 'تأكيد الإغلاق؟',
    deleteTips: 'تأكيد الحذف؟',
    deleteSuccess: 'تم الحذف بنجاح',
    addSuccess: 'تمت الإضافة بنجاح',
    editSuccess: 'تم التعديل بنجاح',
    saveSuccess: 'تم الحفظ',
    tips: 'تنبيه',
    operation: 'عملية',
    query: 'استعلام',
    reset: 'إعادة',
    noData: 'لا توجد بيانات',
    export: 'تصدير',
    success: 'نجاح',
    failure: 'فشل',
    incorrectFormat: 'صيغة غير صحيحة',
    integerFormat: 'يجب أن يكون عدداً صحيحاً ≥0',
    positiveIntegerFormat: 'يجب أن يكون عدداً صحيحاً >0',
    noDataSaved: 'لا توجد بيانات للحفظ',
    chinese: 'الصينية',
    english: 'الإنجليزية',
    spanish: 'الإسبانية',
    french: 'الفرنسية',
    german: 'الألمانية',
    russian: 'الروسية',
    arabic: 'العربية',
    portuguese: 'البرتغالية',
    korean: 'الكورية',
    detail: "التفاصيل",
    clearTips: "هل أنت متأكد من المسح؟",
    clearSuccess: "تم المسح بنجاح",
  },
  log: {
    accessMethod: 'طريقة الدخول',
    passingTime: 'وقت المرور',
    accessPass: 'اعتماد الدخول',
    accessResult: 'النتيجة',
    accessPhoto: 'صورة',
    viewPhotos: 'عرض الصور'
  },
  error: {
    networkError: 'فشل الشبكة، تحقق من الاتصال',
    timeout: 'انتهى الوقت، حاول لاحقاً',
    serverError: 'خطأ داخلي في الخادم',
    notFound: 'المورد غير موجود',
    unauthorized: 'غير مصرح، يرجى تسجيل الدخول',
    noResponse: 'لا يوجد استجابة من الخادم',
    unknownError: 'فشل الطلب، الرمز:',
    requestFailed: 'فشل الطلب'
  },
  security: {
    keyId: "معرف المفتاح",
    keyType: "نوع المفتاح",
    keyEncoding: "ترميز المفتاح",
    keyValue: "قيمة المفتاح",
    startTime: "وقت البدء",
    expirationTime: "وقت الانتهاء",
    newKey: "إضافة مفتاح جديد",
    clearKey: "مسح المفتاح",
    validTime: "الوقت الصالح",
  }
}
